import React from 'react';
import { Image, ComputerIconWrapper } from './styles';
import Computer from 'assets/school-admin/icons/computer.svg'

const ComputerIcon = () => (
  <ComputerIconWrapper><Image src={Computer} /></ComputerIconWrapper>
);

export default ComputerIcon;
